import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import {breakpoint} from "./breakpoints";

gsap.registerPlugin(ScrollTrigger);




// to use add class js-parallax.  by default moves half of element height
//    data-paralax-speed - move speed. default 1.  if enabled paralax-height not working
//    data-paralax-speed-resp - move speed. default 1.  if enabled paralax-height not working
//    data-paralax-height - if need custom move height
//    data-paralax-height-resp - height for devices under 1200px
//    data-paralax-disable-resp   -  do not init in devices under 1200px
gsap.utils.toArray('.js-paralax').forEach((item, index) => {
  let init = true
  let speed_coefficient = $(item).attr('data-paralax-speed') || 1
  let scroll_height = $(item).attr('data-paralax-height') || $(item).outerHeight() / 2
  let container = $(item).attr('data-paralax-container') || item

  
  if (window.outerWidth < 1200){
    scroll_height = $(item).attr('data-paralax-height-resp') || scroll_height;
    speed_coefficient =  $(item).attr('data-paralax-speed-resp') || speed_coefficient;
    if ($(item).attr('data-paralax-disable-resp')) init = false;
  }


  if (speed_coefficient != 1){
    scroll_height = window.outerHeight * speed_coefficient
  }


  if (init){
    let paralax_start_pos = -(scroll_height / 2)

    gsap.fromTo(
      item,
      { y: paralax_start_pos },
      {
        y: scroll_height,
        ease: 'none',
        scrollTrigger: {
          trigger: container,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      }
    );

  }
});




gsap.utils.toArray('.js-parallax-header').forEach((item, index) => {
	let scroll_height = $(item).outerHeight() / 2

  gsap.fromTo(
    item,
    { y: 0 },
    {
      y: scroll_height,
      ease: 'none',
      scrollTrigger: {
        trigger: item,
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }
    }
  );
});
